const notification = {
  markRead: 'Mark Read',
  markReadAll: 'Mark Read All'
};

export default notification;
